import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { DashboardsContext } from "../../../contexts/DashboardsContext";
import useBulkDashboards from "../../../hooks/useBulkDashboards";
import { getDashboardQueriesFunc, getPublicDashboardQueriesFunc } from "../../../lib/helper";
import { collectionKey } from '../../organisms/dashboards/DashboardsView';
import FindInvestorsShareDealModal from "../dashboard-details/FindInvestorsShareDealModal";
import FindInvestorsShareDealsModal from "./FindInvestorsShareDealsModal";
import FindInvestorsShareDealsUnifiedModal from "./FindInvestorsShareDealsUnifiedModal";
import { DashboardQuery } from "../../../types/files";
import { produce } from "immer";

const FindInvestorsShareDealsLoaderModal: React.FC<{
    isOpen: boolean,
    onClose: () => void,
}> = ({ isOpen, onClose }) => {
    const { setDashboardsQueries } = useContext(DashboardsContext)
    const { getBulkDashboards, clearBulk } = useBulkDashboards();
    const [manualSharing, setManualSharing] = useState<boolean>(false);
    const timerRef = useRef<string | number | NodeJS.Timeout | undefined>(undefined);

    const bulkDashboards = useMemo(() =>
        getBulkDashboards(collectionKey).map(bulk => bulk.dashboard)
    , [getBulkDashboards]);

    useEffect(() => {
        return () => {
            clearBulk(collectionKey);
        };
    // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!!bulkDashboards.length && !timerRef.current) {
            timerRef.current = setTimeout(() => {
                clearTimeout(timerRef.current);
                Promise.all(bulkDashboards.map((dashboard) =>  dashboard!.isPublic
                    ? getPublicDashboardQueriesFunc(dashboard!.id)
                    : getDashboardQueriesFunc(dashboard!.id))
                ).then((bulkQueryData: DashboardQuery[][]) => {
                    setDashboardsQueries(prev => produce(prev, draft => {
                        bulkQueryData.flat().forEach(newQuery => {
                            if (!draft.find(query => query.dashboardId === newQuery.dashboardId && query.title === newQuery.title))
                                draft.push(newQuery);
                        });
                    }));
                });
            }, 1000);
        }
    // eslint-disable-next-line
    }, [bulkDashboards]);

    if (bulkDashboards.length === 1)
        return (<FindInvestorsShareDealModal isOpen={isOpen} dashboard={bulkDashboards[0]} onClose={onClose} />);

    if (manualSharing)
        return (<FindInvestorsShareDealsModal isOpen={isOpen} onClose={onClose} />);

    return (
        <FindInvestorsShareDealsUnifiedModal
            isOpen={isOpen && !manualSharing}
            onSwitch={() => setManualSharing(true)}
            onClose={onClose} />
    );
}

export default FindInvestorsShareDealsLoaderModal;